const Profile = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12.3994" cy="9" r="4.75" stroke="#BABABA" strokeWidth="1.5" />
      <path
        d="M19.3994 20.5C19.3994 17.1863 16.2654 14.5 12.3994 14.5C8.53342 14.5 5.39941 17.1863 5.39941 20.5"
        stroke="#BABABA"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default Profile;
